module.exports = __webpack_public_path__ + "img/_2.20cb7486.png";